import { useEffect, useState } from "react";
import { navTabs, tickerItems } from "@/mocks/homeData";
import { Shell } from "./ui";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* 顶部压顶快讯更新条 */}
      <div className="relative z-30 overflow-hidden bg-foreground-950 text-background-50">
        <Shell>
          <div className="flex h-9 items-center gap-3 text-xs">
            <div className="flex shrink-0 items-center gap-1.5 rounded bg-primary-500 px-2 py-0.5 font-semibold text-background-50">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-background-50" />
              </span>
              实况更新
            </div>
            <div className="relative flex-1 overflow-hidden">
              <div className="flex w-max animate-ticker items-center gap-10 whitespace-nowrap">
                {tickerItems.concat(tickerItems).map((t, i) => (
                  <a key={i} href="#top" className="flex items-center gap-2 text-foreground-100 transition hover:text-background-50">
                    <i className="ri-arrow-right-line text-accent-500" />
                    <span className="font-medium">{t}</span>
                  </a>
                ))}
              </div>
            </div>
            <span className="hidden shrink-0 text-foreground-400 sm:inline">2026-09-05 周六</span>
          </div>
        </Shell>
      </div>

      {/* 主站头 */}
      <header
        className={`sticky top-0 z-20 border-b transition-all ${
          scrolled ? "border-background-200 bg-background-50/95 shadow-sm backdrop-blur" : "border-transparent bg-background-50"
        }`}
      >
        <Shell>
          <div className="flex h-16 items-center justify-between gap-4 md:h-[72px]">
            {/* logo */}
            <a href="#top" className="flex shrink-0 items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-spy-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-[22px] font-black tracking-tight text-foreground-950">
                  黑料王
                </span>
                <span className="mt-0.5 text-[10px] font-medium tracking-[0.2em] text-primary-700">
                  反转·打脸·辟谣·实锤·后续
                </span>
              </span>
            </a>

            {/* 桌面导航 */}
            <nav className="hidden items-center gap-1 lg:flex">
              <a href="#top" className="rounded-md px-3 py-2 text-sm font-semibold text-primary-700">
                首页
              </a>
              {navTabs.map((t) => (
                <a
                  key={t.id}
                  href={`#${t.id}`}
                  className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-800"
                >
                  {t.label}
                </a>
              ))}
            </nav>

            {/* 右侧操作 */}
            <div className="flex items-center gap-2">
              <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 md:flex">
                <i className="ri-search-line text-sm text-foreground-500" />
                <input
                  className="w-32 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
                  placeholder="搜索事件 / 人物"
                />
              </div>
              <a
                href="#report"
                className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
              >
                <i className="ri-add-circle-line" />
                发布线索
              </a>
              <button
                aria-label="打开菜单"
                onClick={() => setOpen((v) => !v)}
                className="grid h-10 w-10 place-items-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
              >
                <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
              </button>
            </div>
          </div>
        </Shell>

        {/* 移动端导航 */}
        {open ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <Shell>
              <nav className="grid grid-cols-2 gap-2 py-4">
                <a href="#top" className="rounded-md bg-primary-50 px-3 py-2.5 text-sm font-semibold text-primary-800">
                  首页
                </a>
                {navTabs.map((t) => (
                  <a
                    key={t.id}
                    href={`#${t.id}`}
                    onClick={() => setOpen(false)}
                    className="rounded-md border border-background-200 px-3 py-2.5 text-sm text-foreground-700"
                  >
                    {t.label}
                  </a>
                ))}
                <a href="#report" className="col-span-2 mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50">
                  发布线索
                </a>
              </nav>
            </Shell>
          </div>
        ) : null}
      </header>
    </>
  );
}